import { SwitchButton } from "components/switchButton";
import { IBlogItem } from "interfaces";
import { Link } from "react-router-dom";
import Button from "components/button";
import { EyeIcon, PencilIcon } from "@heroicons/react/outline";
import { TooltipParagraph } from "components/tooltipParagraph";
import moment from "moment";
import { isHaveActionPermission } from "utills/helpers";

interface BlogTableProps {
  data?: IBlogItem[];
  pageSize: number;
  currentPage: number;
  _toggleActive: (id: string, isActive: boolean) => void;
}

export const BlogTable = ({
  data = [],
  pageSize = 10,
  currentPage = 1,
  _toggleActive,
}: BlogTableProps) => {
  return (
    <div className="flow-root">
      <div className="relative inline-block w-full align-middle box-border">
        <table className="w-full divide-y divide-gray-300 bg-magnolia-500 rounded-md">
          <thead>
            <tr>
              <th scope="col" className="th py-3.5 pl-4 pr-3 sm:pl-6 lg:pl-8">
                No
              </th>
              <th scope="col" className="th">
                Title vie
              </th>
              <th scope="col" className="th">
                Category eng
              </th>
              <th scope="col" className="th">
                Sub-category eng
              </th>
              <th scope="col" className="th">
                Hot position
              </th>
              <th scope="col" className="th">
                Publish at
              </th>
              <th scope="col" className="th">
                Status
              </th>
              <th scope="col" className="th w-28">
                <span className="sr-only">Action</span>
                <p className="">Action</p>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {data.map((item: IBlogItem, index: number) => (
              <tr key={index}>
                <td className="td py-4 pl-4 pr-3 sm:pl-6 lg:pl-8">
                  {(currentPage - 1) * pageSize + 1 + index}
                </td>
                <td className="td max-w-32 overflow-x-auto">
                  <TooltipParagraph 
                    text={item.title_vi}
                    className="whitespace-pre-wrap max-w-[280px]"
                  />
                </td>
                <td className="td max-w-10 overflow-x-auto capitalize">
                  {item.category}
                </td>
                <td className="td overflow-x-auto capitalize">
                  {item.sub_category_name_en}
                </td>
                <td className="td overflow-x-auto">
                  {item.is_hot_position ? "Yes" : "No"}
                </td>
                <td className="td overflow-x-auto capitalize">
                  {item.publish_at ? moment(item.publish_at).format("DD/MM/YYYY HH:mm:ss") : ""}
                </td>
                <td className="td overflow-x-auto">
                  <SwitchButton
                    checked={item.is_active}
                    disabled={!isHaveActionPermission("blog", "mkt", "edit")}
                    onChange={() => _toggleActive(item.id, item.is_active)}
                  />
                </td>
                <td className="td py-4 pl-3 pr-4 sm:pr-6 lg:pr-8">
                  <div className="flex justify-start items-end gap-x-2 ">
                    <Link to={`/mkt/blog/${item.id}`} className="w-fit">
                      <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                        <EyeIcon className="w-4 h-4 text-black" />
                      </Button>
                    </Link>
                    {isHaveActionPermission("blog", "mkt", "edit") ? (
                      <Link to={`/mkt/blog/${item.id}/edit`} className="w-fit">
                        <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                          <PencilIcon className="w-4 h-4 text-black" />
                        </Button>
                      </Link>
                    ) : (
                      <></>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
